<div class="secondary-navigation" *ngIf="contact$ | async as contact">
    <ng-container *ngIf="!(collapsed$ | async)">
        <app-topnav (back)="back()" [heading]="contact.Description"> </app-topnav>

        <app-topbar-info>
            <app-topbar-contact-info customNavInfo></app-topbar-contact-info>
        </app-topbar-info>
    </ng-container>

    <div class="topbar-menu">
        <app-menubar id="menubar-contact" [menuItems]="contactMenuItems"></app-menubar>
    </div>

    <app-menubar-scroll *ngIf="isMobile$ | async" [menuName]="menuName.Contact"></app-menubar-scroll>
    <app-menubar-collapse></app-menubar-collapse>
</div>
